<template>
  <div class="modal fade play_now" id="play_now_popup" tabindex="-1" role="dialog"
       aria-labelledby="" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                @click="closeModal()">
          <img src="static/img/millen_images/popup-close.svg" alt="">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Speel en Win!</h5>
        </div>
        <div class="modal-body">
          <form>
            <div :class="{'form-group': true, 'error': !isValidMsisdn}">
              <input v-model="msisdn" type="tel" class="form-control" id="mobile" name="mobile"
                     placeholder="Je mobiele nummer"
                     required/>
              <label v-if="!isValidMsisdn" class="form-control-label" for="mobile"></label>
              <div v-if="!isValidMsisdn" class="error_msg">
                Ongeldig mobiele nummer. Je mobiele nummer moet beginnen met 06 en bestaat uit 10
                cijfers. Of beginnend met 097 en bestaand uit 12 cijfers.
              </div>
            </div>


            <div :class="{'form-group': true, 'error': !isValidCode || !this.getIsCodeValidForRedeem}">
              <input v-model="code" type="text" class="form-control" id="pass" name="pass"
                     placeholder="Je speelcode"
                     required/>
              <label v-if="!isValidCode || !this.getIsCodeValidForRedeem" class="form-control-label" for="pass"></label>
              <div v-if="!isValidCode || !this.getIsCodeValidForRedeem" class="error_msg">
                Oops, je speelcode is niet juist.
              </div>
            </div>


          </form>
          <div class="row">
            <div class="col-12 text-right">
              <button type="button" @click.prevent="lostCode" class="link_btn">Speelcode kwijt?
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" @click.prevent="submitRedeemCode" :disabled="disabled"
                  class="black_btn">Speel nu mee
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations} from 'vuex'
import gtm_analytics from "../../common/mixin/gtm_analytics";

export default {
  name: 'PlayAndWin',
  mixins: [
    gtm_analytics
  ],
  data() {
    return {
      msisdn: null,
      code: null,
      isValidMsisdn: true,
      isValidCode: true,
      disabled: false
    }
  },
  computed: {
    ...mapGetters([
      'getGameFlowState',
      'getIsCodeValidForRedeem'
    ])
  },
  mounted() {
    $('#play_now_popup').modal('show')
    this.pushPopUp('Popup visit','Play Now Pop Up')
  },
  methods: {
    ...mapMutations([
      'updatePlayGameModal',
      'updateAcceptTermsModal',
      'updateLostCodeModal',
      'updateRedemptionMsisdn',
      'updateSelectedCodeForRedemption',
    ]),
    closeModal() {
      this.updatePlayGameModal(false)
      this.updateRedemptionMsisdn(null)
      this.updateSelectedCodeForRedemption(null)
      this.$store.commit('updateIsCodeValidForRedeem', true)
    },
    validateForm() {
      this.isValidMsisdn = this.msisdnValidation()
      this.isValidCode = this.codeValidation()
      return this.isValidMsisdn && this.isValidCode
    },
    msisdnValidation() {
      return (/^(06[0-9]{8}|097[0-9]{9})$/.test(this.msisdn))
    },
    codeValidation() {
      return (/^[0-9]{4}$/.test(this.code))
    },
    submitRedeemCode() {
      if (this.disabled) {
        return
      }
      if (this.validateForm()) {
        this.disabled = true
        this.updateRedemptionMsisdn(this.msisdn)
        this.updateSelectedCodeForRedemption(this.code)
        this.$store.commit('updatePlayGameModal', false)
        $('#play_now_popup').modal('hide')
        this.$store.commit('updateAcceptTermsModal', true)
      }
    },
    lostCode() {
      this.updatePlayGameModal(false)
      this.updateLostCodeModal(true)
      $('#play_now_popup').modal('hide')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/PlayAndWin.vue